export default class ScriptLoader {
    private static loadedScripts: Set<string> = new Set();

    public static loadScript(url: string): Promise<void> {
        return new Promise((resolve, reject) => {

            if (ScriptLoader.loadedScripts.has(url)) {
                resolve();
                return;
            }

            const script = document.createElement('script');
            script.src = url;
            script.async = true;

            script.onload = () => {
                ScriptLoader.loadedScripts.add(url);
                resolve();
            };

            script.onerror = () => {
                reject(new Error(`Failed to load script: ${url}`));
            };

            document.head.appendChild(script);
        });
    }
}
